export default "__VITE_ASSET__JeITSPz2__"